import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../../types/api';
import { AdminBranchPayout } from '../../types/branch/AdminBranchPayout';
import { AdminBranchPayoutReversal } from '../../types/branch/AdminBranchPayoutReversal';
import { BranchPayoutOrder } from '../../types/branch/BranchPayoutOrder';

const URL = '/v2/admin-branch-payout';
const URL_INITIATE_PAYOUT = '/initiate';
const URL_REVERSE_PAYOUT = '/reverse';

class AdminBranchPayoutService {
  static initiatePayout(
    adminBranchPayout: AdminBranchPayout,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AdminBranchPayout>> {
    return axios.post(URL + URL_INITIATE_PAYOUT, adminBranchPayout, config);
  }

  static reversePayout(
    adminBranchPayoutReversal: AdminBranchPayoutReversal,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AdminBranchPayoutReversal>> {
    return axios.post(URL + URL_REVERSE_PAYOUT, adminBranchPayoutReversal, config);
  }

  static getByFilter(
    params: string,
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<BranchPayoutOrder>> {
    return axios.get(`${URL}${params}`, config);
  }
}

export { AdminBranchPayoutService };
